// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".voice-ui[data-v-743d3c88]{height:80px}.voice-ui .play-button[data-v-743d3c88]{vertical-align:top;padding:12px}.voice-ui .play-button[data-v-743d3c88],.voice-ui .waveform[data-v-743d3c88]{display:inline-block;height:80px}", ""]);
// Exports
module.exports = exports;
